/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {BulkProgress} from '../models/BulkProgress';
import type {Error} from '../models/Error';
import type {UpdateRoleGrant} from '../models/UpdateRoleGrant';
import type {UpdateRoleGrantsResult} from '../models/UpdateRoleGrantsResult';

export interface BulkAssignRoleGrants$Request {
    updateRoleGrant: UpdateRoleGrant;
    reason?: string;
}

export interface BulkAssignRoleGrants$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const bulkAssignRoleGrantsRequest = createAction<PayloadData<void, BulkAssignRoleGrants$Request>>('BULK_ASSIGN_ROLE_GRANTS__BULK_ASSIGN_ROLE_GRANTS__REQUEST');
export const bulkAssignRoleGrantsSuccess = createAction<PayloadData<string, BulkAssignRoleGrants$Request>>('BULK_ASSIGN_ROLE_GRANTS__BULK_ASSIGN_ROLE_GRANTS__SUCCESS');
export const bulkAssignRoleGrantsFailure = createAction<PayloadData<Error, BulkAssignRoleGrants$Request, true>>('BULK_ASSIGN_ROLE_GRANTS__BULK_ASSIGN_ROLE_GRANTS__FAILURE');

export const bulkAssignRoleGrantsActions = [
    bulkAssignRoleGrantsRequest,
    bulkAssignRoleGrantsSuccess,
    bulkAssignRoleGrantsFailure
] as const;

/**
 * @param {UpdateRoleGrant} meta.updateRoleGrant
 * @param {string} [meta.reason] Optional audit reason for this update. Blank values use the existing operation-specific reason.
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const bulkAssignRoleGrants = (meta: BulkAssignRoleGrants$Request, config?: BulkAssignRoleGrants$Config) => {
    const TRANSPORT_GET_PARAMS = {
        reason: meta.reason,
    };
    return {
        CALL_API: {
            types: bulkAssignRoleGrantsActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/bulk-actions/roles/assign-grants`,
            TRANSPORT_GET_PARAMS,
            TRANSPORT_REQUEST_BODY: meta.updateRoleGrant,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface BulkAssignRoleGrantsProgress$Request {
    id: string;
}

export interface BulkAssignRoleGrantsProgress$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const bulkAssignRoleGrantsProgressRequest = createAction<PayloadData<void, BulkAssignRoleGrantsProgress$Request>>('BULK_ASSIGN_ROLE_GRANTS__BULK_ASSIGN_ROLE_GRANTS_PROGRESS__REQUEST');
export const bulkAssignRoleGrantsProgressSuccess = createAction<PayloadData<BulkProgress, BulkAssignRoleGrantsProgress$Request>>('BULK_ASSIGN_ROLE_GRANTS__BULK_ASSIGN_ROLE_GRANTS_PROGRESS__SUCCESS');
export const bulkAssignRoleGrantsProgressFailure = createAction<PayloadData<Error, BulkAssignRoleGrantsProgress$Request, true>>('BULK_ASSIGN_ROLE_GRANTS__BULK_ASSIGN_ROLE_GRANTS_PROGRESS__FAILURE');

export const bulkAssignRoleGrantsProgressActions = [
    bulkAssignRoleGrantsProgressRequest,
    bulkAssignRoleGrantsProgressSuccess,
    bulkAssignRoleGrantsProgressFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const bulkAssignRoleGrantsProgress = (meta: BulkAssignRoleGrantsProgress$Request, config?: BulkAssignRoleGrantsProgress$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: bulkAssignRoleGrantsProgressActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/bulk-actions/roles/assign-grants/progress`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetAssignRoleGrantsResult$Request {
    id: string;
}

export interface GetAssignRoleGrantsResult$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAssignRoleGrantsResultRequest = createAction<PayloadData<void, GetAssignRoleGrantsResult$Request>>('BULK_ASSIGN_ROLE_GRANTS__GET_ASSIGN_ROLE_GRANTS_RESULT__REQUEST');
export const getAssignRoleGrantsResultSuccess = createAction<PayloadData<UpdateRoleGrantsResult, GetAssignRoleGrantsResult$Request>>('BULK_ASSIGN_ROLE_GRANTS__GET_ASSIGN_ROLE_GRANTS_RESULT__SUCCESS');
export const getAssignRoleGrantsResultFailure = createAction<PayloadData<Error, GetAssignRoleGrantsResult$Request, true>>('BULK_ASSIGN_ROLE_GRANTS__GET_ASSIGN_ROLE_GRANTS_RESULT__FAILURE');

export const getAssignRoleGrantsResultActions = [
    getAssignRoleGrantsResultRequest,
    getAssignRoleGrantsResultSuccess,
    getAssignRoleGrantsResultFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAssignRoleGrantsResult = (meta: GetAssignRoleGrantsResult$Request, config?: GetAssignRoleGrantsResult$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: getAssignRoleGrantsResultActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/bulk-actions/roles/assign-grants`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

